module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-layout-header', {
    class: [_vm.fixHeader && 'ant-header-fixedHeader', _vm.layout === 'side' ? (_vm.sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed') : null, _vm.theme, 'global-header']
  }, [_c('div', {
    class: ['global-header-wide', _vm.layout]
  }, [(_vm.isMobile || _vm.layout === 'head') ? _c('router-link', {
    class: ['logo', _vm.isMobile ? null : 'pc', _vm.theme],
    attrs: {
      "to": "/"
    }
  }, [(this.$store.state.setting.theme === 'dark') ? _c('img', {
    attrs: {
      "height": "32",
      "src": _vm.logoUrlDark,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (this.$store.state.setting.theme === 'light') ? _c('img', {
    attrs: {
      "height": "32",
      "src": _vm.logoUrlLight,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('h1', [_vm._v(_vm._s(_vm.systemName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('a-divider', {
    attrs: {
      "type": "vertical"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.layout === 'side') ? _c('a-icon', {
    staticClass: "trigger",
    attrs: {
      "type": _vm.collapsed ? 'menu-unfold' : 'menu-fold'
    },
    on: {
      "click": _vm.toggleCollapse
    }
  }) : _vm._e(), _vm._v(" "), (_vm.layout === 'head') ? _c('div', {
    staticClass: "global-header-menu"
  }, [_c('i-menu', {
    staticClass: "system-top-menu",
    staticStyle: {
      "height": "64px",
      "line-height": "64px"
    },
    attrs: {
      "theme": _vm.theme,
      "mode": "horizontal",
      "menuData": _vm.menuData
    },
    on: {
      "select": _vm.onSelect
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['global-header-right', _vm.theme]
  }, [_c('div', {
    staticClass: "header-item"
  }, [_c('a-dropdown', {
    attrs: {
      "placement": "bottomRight"
    },
    model: {
      value: (_vm.noticeCount.noticeVisible),
      callback: function($$v) {
        _vm.$set(_vm.noticeCount, "noticeVisible", $$v)
      },
      expression: "noticeCount.noticeVisible"
    }
  }, [_c('a-badge', {
    staticStyle: {
      "height": "15px",
      "line-height": "15px"
    },
    attrs: {
      "count": _vm.noticeCount.total,
      "overflowCount": 999
    }
  }, [_c('a-icon', {
    staticStyle: {
      "font-size": "1.5em"
    },
    attrs: {
      "type": "read"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "notice-dropdown",
    attrs: {
      "slot": "overlay"
    },
    on: {
      "click": _vm.handleMenuClick
    },
    slot: "overlay"
  }, [(_vm.noticeCount.total > 0) ? _c('a-menu', _vm._l((_vm.noticeCount.noticesData), function(item) {
    return _c('a-menu-item', {
      key: item.noticeId,
      on: {
        "click": function($event) {
          return _vm.handleNoticeClick(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.noticeTitle))])])
  }), 1) : _c('div', {
    staticClass: "ant-empty ant-empty-normal"
  }, [_c('div', {
    staticClass: "ant-empty-image"
  }, [_c('svg', {
    attrs: {
      "width": "64",
      "height": "41",
      "viewBox": "0 0 64 41",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0 1)",
      "fill": "none",
      "fillRule": "evenodd"
    }
  }, [_c('ellipse', {
    attrs: {
      "fill": "#F5F5F5",
      "cx": "32",
      "cy": "33",
      "rx": "32",
      "ry": "7"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fillRule": "nonzero",
      "stroke": "#D9D9D9"
    }
  }, [_c('path', {
    attrs: {
      "d": "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
      "fill": "#FAFAFA"
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "ant-empty-description"
  }, [_vm._v("暂无数据")])])], 1)], 1)], 1), _vm._v(" "), _c('header-avatar', {
    staticClass: "header-item"
  })], 1)], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": _vm.noticeModalTitle,
      "keyboard": false,
      "maskClosable": false,
      "closable": true,
      "footer": null,
      "visible": _vm.noticeModal.modalVisiable,
      "width": 920
    },
    on: {
      "cancel": function () {
        _vm.noticeModal.modalVisiable = false
      }
    }
  }, [_c('a-row', {
    staticClass: "notice-modal-rows"
  }, [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('pre', {
    staticClass: "notice-modal-row-content"
  }, [_vm._v(_vm._s(_vm.noticeModal.modalData.noticeContent))])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-59aa6d9d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/common/GlobalHeader.vue
// module id = w78B
// module chunks = 273